import React, { useState, useRef } from 'react';
import {
    Container,
    Button,
} from "react-bootstrap";
import moment from 'moment';
import { toast } from "react-toastify";

import Loader from '../components/loader';
import { TrashCanIcon } from '../assets/icon';

import styles from "../css/createBatchDesign.module.css";
import updateStyles from "../css/updateBatchDesign.module.css";

import axiosInstance from '../services/baseurl';
import { fileUploadEndPoint, updateBatchEndPoint, batchByIdIdEndpoint,createWinner } from '../services/endpoints';


const UpdateBatch = () => {
    const phoneImg = useRef();
    const tokenImg = useRef();

    const [isLoading, setIsLoading] = useState(false);
    const [PIFile, setPIFile] = useState({});
    const [TIFile, setTIFile] = useState([]);
    const [tokenPrice, setTokenPrice] = useState("");
    const [videoUrl, setVideoUrl] = useState("");
    const [drawDate, setDrawDate] = useState(moment().format("YYYY-MM-DD"));
    const [batchStatus, setBatchStatus] = useState("");
    const [winnerID, setWinnerID] = useState(0);
    const [addedTIFile, setAddedTIFile] = useState([]);
    const [batchId, setBatchId] = useState("");
    const [loadedBatchId, setLoadedBatchId] = useState("");
    const [originalStatus, setOriginalStatus] = useState("");

    const handlePIFileUpload = () => {
        phoneImg.current?.click();
    };
    const handleTIFileUpload = () => {
        tokenImg.current?.click();
    };

    const handleFileUploadApi = (file, type) => {
        const formData = new FormData();
        formData.append("FileData", file);
        setIsLoading(true);
        let token = sessionStorage.getItem('token');
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        axiosInstance
            .post(fileUploadEndPoint, formData,{ timeout: 120000 })
            .then((response) => {
                if (response.data.status !== "Success" || !response.data.payload) {
                    toast.error(response.data.message || "Unable to upload image.");
                    setIsLoading(false);
                    return;
                }
                if (type === "PI") {
                    let obj = {
                        phoneId: response.data.payload.imageName,
                        phoneName: file.name,
                    };
                    setPIFile(obj);
                } else {
                    let Obj = {
                        id: 0,
                        imageURL: response.data.payload.imageName,
                        imageId: response.data.payload.imageId,
                        imageName: file.name,
                        createdDate: new Date(),
                        batchId: 0,
                    };
                    setAddedTIFile((prev) => [...prev, Obj]);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                toast.error(error.response?.data?.message || error.message);
                setIsLoading(false);
            });
    };

    const handleSelectedFiles = (e, name) => {
        const uploadedfile = e.target.files?.[0];
        if (!uploadedfile || isLoading) return;
        e.target.value = "";
        if (!/\.(png|jpe?g)$/i.test(uploadedfile.name)) {
            toast.error("Choose a PNG or JPG image.");
            return;
        }
        switch (name) {
            case "PI":
                let PIfile = uploadedfile;
                handleFileUploadApi(PIfile, "PI");
                break;
            case "TI":
                let TIfile = uploadedfile;
                handleFileUploadApi(TIfile);
                break;
            default:
        }
    };

    const handleFileUploadDelete = (name, indkey) => {
        switch (name) {
            case "PI":
                setPIFile({});
                break;
            case "TI":
                if (indkey < TIFile.length) setTIFile(prev => prev.filter((_, index) => index !== indkey));
                else setAddedTIFile(prev => prev.filter((_, index) => index !== indkey - TIFile.length));
                break;
            default:
        }
    };

    const handleTokenPrice = (e) => {
        let val = e.target.value;
        setTokenPrice(val);
    };
    const handleVideoUrl = (e) => {
        let val = e.target.value;
        setVideoUrl(val);
    };
    const handleDate = (e) => {
        let val = e.target.value;
       
        setDrawDate(val);
    };
    const handleWinnerID = (e) => {
        let val = e.target.value;
        setWinnerID(val);
    };
    const handleBatchStatus = (e) => {
        let val = e.target.value;
        setBatchStatus(val);
    };

    const handleBatchId = (e) => {
        let val = e.target.value;
        setBatchId(val);
    }

    const handleUpdateBatch = () => {
        if (isLoading) return;
        if (!batchId || String(loadedBatchId) !== String(batchId) || !batchStatus || !Number.isFinite(Number(tokenPrice)) || Number(tokenPrice) <= 0 || !Number.isFinite(new Date(drawDate).getTime())) {
            toast.error("Select a batch, a valid draw date, status, and positive token price.");
            return;
        }
        setIsLoading(true);
        const requestData = {
            batchId: batchId,
            phoneId: PIFile.phoneId || "",
            logoId: "",
            drawDate: new Date(drawDate).toISOString(),
            winnerId: Number(winnerID) || 0,
            phoneName: PIFile.phoneName || "",
            logoName: "",
            status: batchStatus,
            url: "",
            amount: Number(tokenPrice),
            winnerURL: videoUrl,
            images: [...addedTIFile],

        };
        let token = sessionStorage.getItem('token');
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        axiosInstance
            .put(updateBatchEndPoint, requestData)
            .then(async (response) => {
                if (response.data.status === "Success") {
                    toast.success(response.data.message);
                    setTIFile(prev => [...prev, ...addedTIFile]);
                    setAddedTIFile([]);
                    setOriginalStatus(batchStatus);
                    if (Number(winnerID) > 0) {
                        let winnerData = {
                            "id": 0,
                            "batchId": batchId,
                            "userId": Number(winnerID),
                            "phoneId": PIFile.phoneId
                        }
                        await axiosInstance
                            .post(createWinner, winnerData)
                            .catch(error => toast.error(error.response?.data?.message || error.message))
                            .then((response) => {
                                if (!response) return;
                                if (response.data.status === "Success") {
                                    toast.success(response.data.message);
                                } else {
                                    toast.error(response.data.message);
                                }
                            })
                    }
                } else {
                    toast.error(response.data.message);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                if (error.response?.status === 400) {
                    toast.error("You cannot update the completed batch.");
                    setIsLoading(false);
                } else {
                    console.error(error, "dsjhkfhkdsjhflj");
                    toast.error(error.message)
                    setIsLoading(false);
                }
            });
    };

    const handleGetBatchById = () => {
        if (isLoading) return;
        if (!/^\d+$/.test(String(batchId)) || Number(batchId) <= 0) {
            toast.error("Enter a valid batch ID.");
            return;
        }
        setIsLoading(true)
        let token = sessionStorage.getItem('token');
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        axiosInstance
            .get(batchByIdIdEndpoint + batchId, {})
            .then((response) => {
              
                if (response.data.status === "Success") {
                    toast.success(response.data.message);
                    if (!response.data.payload) { setIsLoading(false); return; }
                    setLoadedBatchId(batchId);
                    let { amount, drawDate, phoneId, phoneName, status, winnerId, winnerURL, images } = response.data.payload;
                    setTokenPrice(amount ?? "");
                    setVideoUrl(winnerURL || "");
                    setWinnerID(winnerId || 0);
                    setDrawDate(moment(drawDate).format("YYYY-MM-DD"));
                    setTIFile(images || []);
                    setAddedTIFile([]);
                    setBatchStatus(status);
                    setOriginalStatus(status)
                    let obj = {
                        phoneId: phoneId,
                        phoneName: phoneName,
                    };
                    setPIFile(obj);
                    setIsLoading(false);
                } else {
                    toast.error(response.data.message);
                    setIsLoading(false);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                toast.error(error.response?.data?.message || error.message);
                setIsLoading(false);
            });
    }

    const isBatchLoaded = Boolean(loadedBatchId) && String(loadedBatchId) === String(batchId);
    const readOnly = originalStatus === "C" || originalStatus === "D";
    const canEdit = isBatchLoaded && !readOnly && !isLoading;
    const statusOptions = [
        { value: "A", label: "Active", detail: "Available now" },
        { value: "P", label: "Pending", detail: "Waiting to go live" },
        { value: "C", label: "Completed", detail: "Draw finished" },
        { value: "D", label: "Deleted", detail: "Removed from sale" },
    ];
    const allowedStatuses = { P: ["P", "A", "D"], A: ["A", "C"], C: ["C"], D: ["D"] };
    const selectedStatus = statusOptions.find(option => option.value === batchStatus);
    const canSave = canEdit && Number.isFinite(Number(tokenPrice)) && Number(tokenPrice) > 0 && Number.isFinite(new Date(drawDate).getTime()) && Boolean(batchStatus);
    const canAddImages = canEdit && batchStatus === "P";
    const UploadMark = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><path d="M12 16V4m-4 4 4-4 4 4M4 15v5h16v-5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    return (
        <Container fluid className="p-0 dashboard-glass admin-theme">
            {isLoading && <Loader />}
            <div className="admin-page">
                    <main className={styles.workspace}>
                        <header className={styles.pageHeader}><div><span className={styles.eyebrow}>YOUR COLLECTIONS</span><h1>Update a batch</h1><p>Fine-tune your collection, manage the draw, and keep every detail up to date.</p></div><span className={styles.draftBadge}><span />{isBatchLoaded ? `Batch #${loadedBatchId}` : "Manage a batch"}</span></header>
                        <section className={`${styles.panel} ${updateStyles.lookup}`} aria-label="Find a batch">
                            <div className={styles.sectionTitle}><span className={styles.step}>01</span><div><h2>Find your batch</h2><p>Enter its ID to load the current images and settings.</p></div></div>
                            <div className={updateStyles.lookupControls}><div className={updateStyles.lookupInput}><label htmlFor="lookup-batch-id">Batch ID</label><input id="lookup-batch-id" inputMode="numeric" placeholder="e.g. 1024" value={batchId} onChange={handleBatchId} disabled={isLoading} onKeyDown={event => { if (event.key === "Enter") handleGetBatchById(); }} /></div><Button type="button" className={styles.primaryButton} onClick={handleGetBatchById} disabled={isLoading || !batchId}>Load batch <span aria-hidden="true">&#8599;</span></Button></div>
                        </section>
                        {!isBatchLoaded ? <section className={`${styles.panel} ${updateStyles.emptyState}`}><span className={styles.uploadIcon}><UploadMark /></span><h2>{loadedBatchId ? "Load the selected batch" : "Every detail, in one place"}</h2><p>{loadedBatchId ? "The batch ID has changed. Load its details before making updates." : "Your images, pricing, and draw details will appear here once you load a batch."}</p><div className={updateStyles.emptyTags}><span>Image collection</span><span>Batch settings</span><span>Winner details</span></div></section> : <>
                            {readOnly && <p className={updateStyles.notice}>This batch is {originalStatus === "C" ? "completed" : "deleted"}. You can review its details here.</p>}
                            <div className={styles.layout}>
                                <div className={styles.settings}>
                                    <section className={styles.panel} aria-labelledby="update-images-title">
                                        <div className={styles.sectionHeader}><div className={styles.sectionTitle}><span className={styles.step}>02</span><div><h2 id="update-images-title">Image collection</h2><p>Review the collection and add images to a pending batch.</p></div></div><span className={styles.count}>{TIFile.length + addedTIFile.length} images</span></div>
                                        {canAddImages && <div className={styles.uploadArea}><span className={styles.uploadIcon}><UploadMark /></span><h3>A fresh addition to your collection</h3><p>Upload another image to include in this batch.</p><Button type="button" className={styles.primaryButton} onClick={handleTIFileUpload}><UploadMark /> Add image</Button><small>PNG or JPG images</small></div>}
                                        {TIFile.length + addedTIFile.length ? <div className={styles.imageGrid}>{[...TIFile, ...addedTIFile].map((file, index) => <article key={`${file.imageId}-${index}`} className={styles.imageCard}><div className={styles.preview}><img src={file.imageURL} alt={file.imageName || `Batch image ${index + 1}`} /><span className={styles.imageNumber}>{index < TIFile.length ? "Saved" : "New"}</span></div><div className={styles.imageInfo}><div><h3 title={file.imageName}>{file.imageName || `Image ${index + 1}`}</h3><p>{index < TIFile.length ? "In this collection" : "Added to this update"}</p></div>{index >= TIFile.length && canEdit && <Button type="button" className={styles.removeButton} aria-label={`Remove ${file.imageName}`} onClick={() => handleFileUploadDelete("TI", index)}><TrashCanIcon /></Button>}</div></article>)}</div> : <p className={styles.emptyNote}>No images in this collection yet.</p>}
                                    </section>
                                    <section className={styles.panel} aria-labelledby="winner-details-title">
                                        <div className={styles.sectionTitle}><span className={styles.step}>03</span><div><h2 id="winner-details-title">Winner details</h2><p>Manage the winner image and draw information.</p></div></div>
                                        <div className={updateStyles.winnerLayout}><div className={updateStyles.winnerPreview}>{PIFile.phoneId ? <><img src={PIFile.phoneId} alt={PIFile.phoneName || "Winner image"} /><p>{PIFile.phoneName || "Winner image"}</p></> : <div className={updateStyles.noWinner}><UploadMark /><span>No winner image</span></div>}{canEdit && <div className={updateStyles.winnerActions}><Button type="button" onClick={handlePIFileUpload} className={styles.primaryButton}>{PIFile.phoneId ? "Replace image" : "Add winner image"}</Button>{PIFile.phoneId && <Button type="button" className={styles.removeButton} aria-label="Remove winner image" onClick={() => handleFileUploadDelete("PI")}><TrashCanIcon /></Button>}</div>}</div><div><div className={styles.field}><label htmlFor="winner-id">Winner ID</label><input id="winner-id" type="number" min="0" step="1" placeholder="Enter user ID" value={winnerID || ""} onChange={handleWinnerID} disabled={!canEdit} /><small>Leave empty if a winner has not been selected.</small></div><div className={styles.field}><label htmlFor="winner-video">Winner video URL</label><input id="winner-video" type="url" placeholder="https://" value={videoUrl} onChange={handleVideoUrl} disabled={!canEdit} /></div></div></div>
                                    </section>
                                </div>
                                <aside className={styles.settings}>
                                    <section className={styles.panel} aria-labelledby="update-settings-title"><div className={styles.sectionTitle}><span className={styles.step}>04</span><div><h2 id="update-settings-title">Batch settings</h2><p>Adjust pricing, the draw date, and status.</p></div></div><div className={styles.field}><label htmlFor="update-price">Token price <span>*</span></label><div className={styles.priceInput}><span aria-hidden="true">&#8377;</span><input id="update-price" type="number" min="0.01" step="0.01" value={tokenPrice} onChange={handleTokenPrice} disabled={!canEdit} /></div><small>Price per token, in Indian rupees.</small></div><div className={styles.field}><label htmlFor="draw-date">Draw date <span>*</span></label><input id="draw-date" type="date" value={drawDate} onChange={handleDate} disabled={!canEdit} /></div><fieldset className={styles.statusField}><legend>Batch status <span>*</span></legend><div className={styles.statusGrid}>{statusOptions.filter(option => (allowedStatuses[originalStatus] || [originalStatus]).includes(option.value)).map(option => <label key={option.value} className={`${styles.statusOption} ${batchStatus === option.value ? styles.selected : ""}`}><input type="radio" name="batchStatus" value={option.value} checked={batchStatus === option.value} onChange={handleBatchStatus} disabled={!canEdit} /><span><strong>{option.label}</strong><small>{option.detail}</small></span></label>)}</div></fieldset></section>
                                    <section className={`${styles.panel} ${styles.summary}`} aria-label="Update summary"><span className={styles.eyebrow}>AT A GLANCE</span><h2>Review your update</h2><dl><div><dt>Batch</dt><dd>#{loadedBatchId}</dd></div><div><dt>Images</dt><dd>{TIFile.length + addedTIFile.length}{addedTIFile.length ? ` (${addedTIFile.length} new)` : ""}</dd></div><div><dt>Token price</dt><dd>{Number.isFinite(Number(tokenPrice)) && Number(tokenPrice) > 0 ? new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(Number(tokenPrice)) : "Not set"}</dd></div><div><dt>Draw date</dt><dd>{drawDate ? moment(drawDate).format("DD MMM YYYY") : "Not set"}</dd></div><div><dt>Status</dt><dd>{selectedStatus?.label || "Not selected"}</dd></div></dl><p>Check the details before saving changes to your batch.</p></section>
                                </aside>
                            </div>
                            <footer className={styles.actionBar}><div><strong>{readOnly ? "Batch details" : "Ready for your review"}</strong><p>{readOnly ? "This batch is available for viewing." : "Your changes will be saved when you update the batch."}</p></div><Button type="button" className={styles.primaryButton} disabled={!canSave} onClick={handleUpdateBatch}>Save changes <span aria-hidden="true">&#8599;</span></Button></footer>
                        </>}
                    </main>
                </div>
            <input type="file" hidden ref={phoneImg} aria-label="Choose winner image" accept=".png,.jpg,.jpeg" onChange={event => handleSelectedFiles(event, "PI")} />
            <input type="file" hidden ref={tokenImg} aria-label="Choose batch image" accept=".png,.jpg,.jpeg" onChange={event => handleSelectedFiles(event, "TI")} />
        </Container>
    );
};

export default UpdateBatch;
